<template>
  <div
  >
    <email-nav
      v-if="isEmail"
      :emailId="emailId"
    />

    <div
      v-if="!base.loading"
    >
      <div
        v-if="!email.confirmed_at"
      >
        <div
          class="form-group"
          v-if="showPrepConfirmEmail"
        >
          <button
            type="submit"
            class="btn btn-primary btn-block"
            v-on:click.prevent="postConfirmation"
          >
            Confirm This Email

            <spinner
              size="small"
              v-if="loading"
            />
          </button>
        </div>
      </div>

      <p
        class="alert alert-danger text-center"
        v-if="needsPuzzle"
      >
        This {{ relationalIdName }} should probably have a puzzle, but no puzzle is attached!
      </p>

      <h2>
        {{ title }} '{{ email.display_name }}'
      </h2>

      <h3>{{ title }} Details</h3>

      <p
        class="alert alert-danger text-center"
        v-if="doesViolateSizeCap(totalAttachmentSize)"
      >
        {{ sizeCapAlertContent }}
      </p>

      <table
        class="table"
      >
        <tr
          v-if="isNewsletter"
        >
          <td>
            {{ title }} Type
          </td>
          <td v-if="email.newsletter_type">
            <router-link :to="{
              name: 'newsletter_type',
              params: {
                newsletterTypeId: email.newsletter_type.id
              }
            }">
              {{ email.newsletter_type.attributes.name }}
            </router-link>
          </td>
          <td v-else>
            N/A
          </td>
        </tr>
        <tr
          v-if="email.provider"
        >
          <td>
            Associated Puzzle Type
          </td>
          <td v-if="email.provider.id">
            <router-link :to="{
              name: 'provider',
              params: {
                providerId: email.provider.id
              }
            }">
              {{ email.provider.attributes.title }}
            </router-link>
          </td>
          <td v-else>
            N/A
          </td>
        </tr>

        <tr
          v-if="!isNewsletter"
        >
          <td>
            Email Name
          </td>
          <td>
            {{ email.display_name }}
          </td>
        </tr>
        <tr>
          <td>
            Subject
          </td>
          <td
            class="d-flex justify-content-between"
          >
            <span>
              {{ email.subject }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            Sender
          </td>
          <td>
            <div
              class="row"
            >
              <div
                class="col"
              >
                {{ email.sender_email }}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Send At (UTC)
          </td>
          <td>
            {{ $root.prettyDateTimeFmt(email.send_at) }}
          </td>
        </tr>
        <tr>
          <td>
            Send At (Your Local Time)
          </td>
          <td>
            {{ prettySendAtLocal }}
            <button
              class="btn btn-sm btn-warning"
              v-on:click="markAsSent"
              v-if="canMarkAsSent"
            >
              Mark As Sent
            </button>

            <button
              class="btn btn-sm btn-danger"
              v-on:click="dequeue"
              v-if="canDequeue"
            >
              Dequeue
            </button>

          </td>
        </tr>
        <tr
          v-if="email.sent_at"
        >
          <td>
            Sent At (UTC)
          </td>
          <td>
            {{ $root.prettyDateTimeFmt(email.sent_at) || "Has not been sent" }}
          </td>
        </tr>
        <!-- // needs better PA implementation
        <tr>
          <td>
            Subscriber Count
          </td>
          <td>
            {{ this.$root.displayDateTimeFmt(email.sent_at) || "Has not been sent" }}
          </td>
        </tr>
        -->
        <tr>
          <td>
            Users Emailed
          </td>
          <td>
            {{ email.sent_recipient_count }}
            <!-- WIP
            <button
              class="btn btn-primary btn-sm"
              v-on:click="emailReport"
            >
              Email Report
            </button>
            -->
          </td>
        </tr>
        <tr
          v-if="email.unsent_recipient_count"
        >
          <td>
            Users Pending Emails
          </td>
          <td>
            {{ email.unsent_recipient_count }}
          </td>
        </tr>
        <tr>
          <td>
            Attached Puzzles
          </td>
          <td>
            <ol v-if="email.puzzles && email.puzzles.length">
              <li v-for="puzzle in email.puzzles">
                <router-link :to="{ name: 'puzzle', params: { puzzleId: puzzle.id }}">
                  Puzzle {{ puzzle.name }}
                  <span
                    class="badge badge-primary"
                  >
                    #{{ puzzle.id }}
                  </span>
                  <span
                    v-html="getAttachmentSizeBadge(
                      kbToMb(puzzle.attachments_total_size)
                    )"
                  ></span>
                </router-link>
              </li>
            </ol>
            <p v-else>
              No attached puzzles.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            Digest?
          </td>
          <td>
            <boolean-badge
              :badgeVal="email.digest"
            />
          </td>
        </tr>
        <tr>
          <td>
            Archived?
          </td>
          <td>
            <boolean-badge
              :badgeVal="email.archived"
            />
          </td>
        </tr>
        <tr>
          <td>
            Draft?
          </td>
          <td>
            <boolean-badge
              :badgeVal="email.inactive"
            />
          </td>
        </tr>

        <tr>
          <td>
            Subscribers Only?
          </td>
          <td>
            <boolean-badge
              :badgeVal="email.subscribers_only"
            />
          </td>
        </tr>

        <tr>
          <td>
            Created By
          </td>
          <td>
            <div
              v-if="email.created_by && email.created_by.id"
            >
              <router-link
                :to="{
                  name: 'user',
                  params: {
                    userId: email.created_by.id
                  }
                }"
              >
                {{ userDisplayName(email.created_by) }}
              </router-link>
            </div>
            <span
              v-else
            >
              n/a
            </span>
          </td>
        </tr>
        <tr>
          <td>
            Confirmation Requested At
          </td>
          <td>
            <div
              v-if="email.confirmation_requested_at"
            >
              {{ $root.displayDateTimeFmt(email.confirmation_requested_at) }}
              by
              <router-link
                :to="{
                  name: 'user',
                  params: {
                    userId: email.confirmation_requested_by.id
                  }
                }"
              >
                {{ userDisplayName(email.confirmation_requested_by) }}
              </router-link>
            </div>
            <span
              v-else
            >
              n/a
            </span>
          </td>
        </tr>

        <tr>
          <td>
            Confirmed At
          </td>
          <td
            v-if="email.confirmed_at"
          >
            {{ $root.displayDateTimeFmt(email.confirmed_at) }}
            by
            <router-link
              :to="{
                name: 'user',
                params: {
                  userId: email.confirmed_by.id
                }
              }"
              v-if="email.confirmed_by"
            >
              {{ userDisplayName(email.confirmed_by) }}
            </router-link>
          </td>
          <td
            v-else
          >
            <span
              class="badge badge-sm badge-danger"
            >
              Not Confirmed
            </span>

            <button
              class="btn btn-sm btn-warning"
              v-on:click.prevent="prepConfirmEmailAction"
            >
              Manually Confirm
            </button>
          </td>
        </tr>

        <tr>
          <td>
            Created At
          </td>
          <td>
            {{ $root.displayDateTimeFmt(email.created_at) }}
          </td>
        </tr>

        <tr>
          <td>
            Updated At
          </td>
          <td>
            {{ $root.displayDateTimeFmt(email.updated_at) }}
          </td>
        </tr>
      </table>


      <div
        v-if="isEmail"
      >
        <hr />

        <h3>Email Criteria</h3>

        <table
          class="table"
        >
          <tr>
            <td>Purchased Before</td>
            <td>{{ email.criteria.purchase.end_at || 'n/a' }}</td>
          </tr>
          <tr>
            <td>Purchased After</td>
            <td>{{ email.criteria.purchase.start_at || 'n/a' }}</td>
          </tr>

          <tr>
            <td>Purchasable Items</td>
            <td>
              <ol>
                <li
                  v-for="item in email.purchasable_items_criteria"
                >
                  <router-link
                    :to="{
                      name: 'purchasable_item',
                      params: {
                        purchasableItemId: item.id
                      }
                    }"
                  >
                    {{ item.name }}
                  </router-link>
                </li>
              </ol>
            </td>
          </tr>

          <tr>
            <td>Tags</td>
            <td>
              <ol
                v-if="!email.criteria.purchase.no_tags"
              >
                <li
                  v-for="item in email.tags_criteria"
                >
                  <router-link
                    :to="{
                      name: 'tag',
                      params: {
                        tagId: item.id
                      }
                    }"
                  >
                    {{ item.name }}
                  </router-link>
                </li>
              </ol>
              <p
                class="alert alert-warning text-center"
                v-else
              >
                Users with tagged purchases will not be emailed.
              </p>
            </td>
          </tr>
        </table>
      </div>

      <hr />

      <div>
        <h3>{{ title }} Content</h3>

        <hr />

        <h4>HTML {{ title }}:</h4>

        <div v-html="email.html_text"></div>
      </div>

      <div>
        <h4>Text {{ title }}:</h4>
        <pre>{{ email.plain_text }}</pre>
      </div>

      <div v-if="email.puzzle_id">
        <router-link :to="{ name: 'puzzle', params: { puzzleId: email.puzzle_id } }">Related Puzzle</router-link>
      </div>

      <hr />

      <h3>Attachments</h3>

      <hr />

      <div
        class="alert alert-info" role="alert"
        v-if="email.puzzle_id"
      >
        This includes all attachments for the related puzzle.
      </div>

      <ol
        v-if="attachments && attachments.length > 0"
      >
        <li v-for="attachment in attachments">
          {{ attachment.name }} - {{ Math.ceil(attachment.byte_size / 1024) }}kb
          <router-link
            :to="{
              name: 'email_attachment',
              params: {
                attachmentId: attachment.id,
                emailId: email.id,
                emailType: emailType
              }
            }"
          >
            Info
          </router-link> -

          <email-attachment-download
            :emailId="email.id"
            :attachmentId="attachment.id"
            :emailType="emailType"
          ></email-attachment-download>

        </li>
      </ol>
      <div v-else>
        <p>
          No attachments.
        </p>
      </div>

      <p>
        <button
          class="btn btn-danger btn-block"
          v-on:click.prevent="deleteEmail"
        >
          Delete {{ title }}
        </button>
      </p>

      <h3>Deployment Options</h3>

      <hr />

      <flash></flash>

      <div
        class="form-group"
        v-if="isNewsletter"
      >
        <button
          class="btn btn-danger btn-block"
          style="pointer-events: none;"
          type="button"
          disabled
          v-if="doesViolateSizeCap(totalAttachmentSize)"
        >
          Cannot Queue {{ title }} for Sending
        </button>
        <div
          class="form-group"
          v-else
        >
          <div
            v-if="canQueue"
          >
            <button
              type="button"
              class="btn btn-primary form-control"
              data-toggle="modal"
              data-target="#queue-email-modal"
            >
              Queue {{ title }} for Sending
              <spinner size="small" v-if="loading"></spinner>
            </button>

            <div class="modal" id="queue-email-modal">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Queue {{ title }} for Sending</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                    <div class="modal-body">
                      <flash></flash>
                      <p
                        class="alert alert-danger text-center"
                      >
                        Are you sure you want to queue this {{ emailType }}? If so, the {{ emailType }} will be immediately queued to send.
                      </p>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-primary"
                        v-on:click="queue"
                      >
                        Queue
                        <spinner size="small" v-if="loading"></spinner>
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <div
            v-else
          >
            <div
              class="form-group"
            >
              <button
                type="button"
                class="btn btn-danger form-control"
                v-on:click.prevent="requeue"
                v-if="canRequeue"
              >
                Re-queue {{ title }} for Sending
                <spinner size="small" v-if="loading"></spinner>
              </button>
            </div>
            <div
              class="form-group"
            >
              <button
                type="button"
                class="btn btn-danger form-control"
                v-on:click.prevent="dequeue"
                v-if="!canQueue"
              >
                Dequeue {{ title }} Recipients
                <spinner size="small" v-if="loading"></spinner>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
      >
        <p
          class="alert alert-info text-center"
          v-if="!email.sent_at"
        >
          Targeted emails do not require manually email queuing.
        </p>
      </div>

      <email-send-to-emails
        :emailId="email.id"
        :emailType="emailType"
        :hitSizeCap="doesViolateSizeCap(totalAttachmentSize)"
      ></email-send-to-emails>
    </div>
    <spinner
      size="huge"
      v-else
    />
    <email-draft
      :emailId="emailId"
      :newsletterId="newsletterId"
      :email="email"
      v-if="!isNewsletter"
    />
    <email-queue-footer
      :newsletterId="newsletterId"
      :emailType="relationalIdName"
      v-if="needsQueuing"
    />
  </div>
</template>
<script>
import BooleanBadge from '@/components/utils/BooleanBadge'
import EmailConfirm from '@/components/EmailConfirm'
import EmailDraft from '@/components/EmailDraft'
import EmailNav from '@/components/EmailNav'
import EmailQueueFooter from '@/components/EmailQueueFooter'
import Flash from '@/components/Flash'
import EmailAttachmentDownload from '@/components/EmailAttachmentDownload'
import EmailSendToEmails from '@/components/EmailSendToEmails'
import PreviewRecipientEmail from '@/components/PreviewRecipientEmail'

import Spinner from 'vue-simple-spinner'

import FlashStore from '@/stores/FlashStore'

import EmailMixin from '@/mixins/EmailMixin'

export default {
  // Deprecate once other async methods are moved to `EmailModule`.
  data () {
    return {
      created_by: {},
      loading: false,
      puzzle_link_id: 0,
      provider: {},
      puzzles: [],
      puzzleAttachmentTotal: 0,
      showPrepConfirmEmail: false
    }
  },

  props: {
    sendEmailConfirmation: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    alreadyConfirmed () {
      return this.email.confirmed_at && this.confirmEmail
    },

    canMarkAsSent () {
      return !this.email.sent_at && this.email.unsent_recipient_count > 0
    },

    sizeCapAlertContent () {
      return `This ${this.title.toLowerCase()}'s attachments total over ${this.attachmentSizeCapLbl},
        which prevents the ${this.title.toLowerCase()} from being sent to users.`
    },

    totalAttachmentSize () {
      let attachmentTotals = this.email.puzzles.map(puzzle => puzzle.attachments_total_size)
      attachmentTotals = attachmentTotals.concat(
        this.attachments.map(attachment => attachment.byte_size)
      )

      attachmentTotals = attachmentTotals.length ? attachmentTotals : [ 0 ]

      const reducer = (accumulator, currentValue) => accumulator + currentValue

      return this.kbToMb(attachmentTotals.reduce(reducer))
    }
  },

  components: {
    'boolean-badge': BooleanBadge,
    'email-confirm': EmailConfirm,
    'email-draft': EmailDraft,
    'email-nav': EmailNav,
    'email-queue-footer': EmailQueueFooter,
    'flash': Flash,
    'email-attachment-download': EmailAttachmentDownload,
    'email-send-to-emails': EmailSendToEmails,
    'preview-email': PreviewRecipientEmail,
    'spinner': Spinner
  },

  mixins: [ EmailMixin ],

  created () {
    this.get().then(() => {
      if (this.sendEmailConfirmation) {
        if (this.alreadyConfirmed) {
          this.showConfirmationError()
        } else {
          this.postConfirmation()
        }
      }
    }, this.$root.processErrors)
  },

  methods: {
    postConfirmation () {
      this.confirmEmail().then(() => {
        FlashStore.result('You have confirmed this email and it can be sent!')

        this.get().then(() => {
          if (confirm('Do you want to queue this email?')) {
            this.queue()
          }
        })
      }, this.$root.processErrors)
    },

    showConfirmationError () {
      FlashStore.error('This email has already been confirmed.')
    },

    prepConfirmEmailAction () {
      this.showPrepConfirmEmail = true

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },

    prepResendEmails () {
      this.newsletterSendToEmailsVisibility = true
    },

    dequeue () {
      if (
        confirm(`Are you sure you want to dequeue this ${this.emailType}? If so, the pending ${this.emailType} recipients will be immediately removed from the queue.`)
      ) {
        this.loading = true

        this.$http.post(this.emailUrl + '/dequeue').then((resp) => {
          this.loading = false

          FlashStore.result('This email has been dequeued.')
          this.get()
        }, this.$root.processErrors)
      }
    },

    requeue () {
      if (!this.promptForPuzzle()) { return }

      if (
        confirm(`Are you sure you want to re-queue this ${this.emailType}? If so, the ${this.emailType} will be immediately queued to send.`)
      ) {
        this.loading = true

        this.$http.post(this.emailUrl + '/queue').then((resp) => {
          this.loading = false

          FlashStore.result('This email has been requeued for sending.')
          this.get()
        }, this.$root.processErrors)
      }
    },

    markAsSent () {
      if (
        confirm(`Are you sure you want to mark this ${this.emailType} as sent? This will halt sending any pending emails.`)
      ) {
        this.loading = true

        this.$http.post(this.emailUrl + '/mark_as_sent').then(() => {
          this.loading = false

          FlashStore.result('This email has been marked as sent.')
          this.get()
        }, this.$root.processErrors)
      }
    },

    createCampaign () {
      this.$http.post(this.emailUrl + '/upload').then(response => {
        this.processSuccess(response)
      }, this.$root.processErrors)
    },

    emailReport () {
      this.loading = true

      this.$http.post(this.emailUrl + '/email_report').then(response => {
        this.loading = false

        FlashStore.result('This email report has been emailed.')
      }, this.$root.processErrors)
    },

    deleteEmail () {
      if (confirm('This will delete the email and cannot be undone. Are you sure you want to delete this?')) {
        this.$http.delete(this.emailUrl).then((resp) => {
          this.$router.push({
            name: this.pluralIdName
          })

          FlashStore.result('This email has been deleted.')
        }, this.$root.processErrors)
      }
    },

    userDisplayName (user) {
      return user.name || user.username
    }
  }
}
</script>

<style scoped>
.nav {
  border-top: 0;
  margin-bottom: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Email.vue